import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { ReactNode } from 'react';
import { DotsSixVertical } from '@phosphor-icons/react';

interface SortableBlockProps {
  id: string;
  children: ReactNode;
}

export const SortableBlock = ({ id, children }: SortableBlockProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div ref={setNodeRef} style={style} className="relative group">
      {/* Drag Handle - positioned on right side, appears on hover */}
      <button
        className="absolute top-3.5 right-3 z-20 opacity-0 group-hover:opacity-100 transition-opacity bg-white border border-neutral-primary/20 rounded-lg shadow-md p-1.5 cursor-grab active:cursor-grabbing hover:bg-moss-primary/10 hover:border-moss-primary/40"
        {...attributes}
        {...listeners}
        aria-label="Drag to reorder"
        onClick={(e) => e.preventDefault()}
      >
        <DotsSixVertical size={16} className="text-neutral-primary" weight="bold" />
      </button>
      
      {/* Block Content */}
      {children}
    </div>
  );
};

